var exports = {
  "Kk": "xcc377c0b--732784--icon",
  "S$": "xcc377c0b--732784--agency",
  "Qq": "xcc377c0b--732784--text",
  "DD": "xcc377c0b--732784--title",
  "VA": "xcc377c0b--732784--subtitle",
};

module.exports = exports;
